import React, { useCallback } from 'react';
import {
  FieldCheckBox,
  FieldDatepicker,
  FieldInput,
  FieldTextArea,
  FormCol,
  FormCol3,
  FormRow,
} from 'motion-components';
import { FormFieldCollectionPointDlg } from 'shared-pages/components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
// TODO: replace with actual container type select component
import { FieldSelectContainerType } from 'shared-pages';
import { useRef, useEffect } from 'react';
import { isAfisCyprus } from 'shared-pages/common/constants';

const QrCodeFormFields = ({ isNew, data }) => {
  const { values, setFieldValue, errors }: any = useFormikContext();
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  // define at the top of the component (just below const { t } = useTranslation();)
  const geoLabel = useCallback(
    (label: string) => {
      if (data && data.latitude && data.longitude) {
        return (
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`}
            target="_blank"
            rel="noreferrer"
          >
            {label}
          </a>
        );
      }
      return label;
    },
    [data],
  );

  const cpFieldRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = cpFieldRef.current;
    if (!root) return;

    // color ONLY the text box
    const input = root.querySelector('input.form-control') as HTMLInputElement | null;
    if (input) input.style.setProperty('background-color', '#fff8d5', 'important');

    // remove the wrapper’s yellow (dialog’s required highlight)
    const group = root.querySelector('.input-group') as HTMLElement | null;
    if (group) group.style.setProperty('background-color', 'transparent', 'important');
  }, []);

  function calcUserCanEdit() {
    const canEdit = appStore?.isPlatformOwner || isNew;
    return { canEdit, canEditReasoning: '' };
  }
  const { canEdit } = calcUserCanEdit();

  const onCollectionPointIdChange = useCallback(
    (valueId: string, valueName: string): void => {
      setFieldValue('collectionPointId', valueId);
      setFieldValue('collectionpoint.name', valueName);
    },
    [setFieldValue],
  );

  const onContainerTypeChange = useCallback(
    (option: any): void => {
      const val = Number(option?.value);
      if (!option || isNaN(val)) {
        setFieldValue('containerTypeId', null);
        setFieldValue('containertype.name', '');
        return;
      }
      setFieldValue('containerTypeId', val);
      setFieldValue('containertype.name', option.label);
    },
    [setFieldValue],
  );

  return (
    <div>
      {/* First Row */}
      <FormRow>
        {/* <FormCol className="col-md">
          <FieldInput label={t('ID')} name="id" disabled readOnly />
        </FormCol> */}
        <FieldDatepicker
          as={FormCol}
          label={'Ημερομηνία Δήλωσης'}
          name={'declaredDate'}
          showTimeSelect={true}
          dateFormat="d/M/yyyy hh:mm"
          disabled={!canEdit}
        />

        <FieldInput
          as={FormCol}
          label={
            <a href={values.qrCode} target="_blank" rel="noopener noreferrer">
              {t('QR Code')}
            </a>
          }
          name="qrCode"
          disabled={!canEdit}
          required
        />

        <FormCol className="col-md">
          <div ref={cpFieldRef}>
            <FormFieldCollectionPointDlg
              label={t('Σημείο Συλλογής')}
              disabled={!canEdit}
              idFieldName="collectionPointId"
              nameFieldName="collectionpoint.name"
              onChange={onCollectionPointIdChange}
              required
            />
          </div>
          {errors.collectionPointId && (
            <div className="invalid-feedback">{errors.collectionPointId}</div>
          )}
        </FormCol>

        <FormCol className="col-md">
          <FieldSelectContainerType
            name="containerTypeId"
            label={t('Τύπος Συσκευασίας')}
            onChange={onContainerTypeChange}
            disabled={!canEdit}
            required
          />
        </FormCol>
      </FormRow>

      {/* Second Row */}
      <FormRow>
        {isAfisCyprus && (
          <FormCol className="col-md">
            <FieldInput label={t('Αριθμός Κάδου')} name="binSerialNo" disabled={!canEdit} />
          </FormCol>
        )}
        <FormCol className="col-md">
          <FieldInput
            label={geoLabel(t('Γεωγραφικό πλάτος (Latitude)'))}
            name="latitude"
            type="number"
            step="any"
            disabled={!canEdit}
          />
        </FormCol>

        <FormCol className="col-md">
          <FieldInput
            label={geoLabel(t('Γεωγραφικό μήκος (Longitude)'))}
            name="longitude"
            type="number"
            step="any"
            disabled={!canEdit}
          />
        </FormCol>

        <FormCol className="col-md">
          <FieldCheckBox
            disabled={!canEdit}
            label={t('Ενεργό')}
            name="isActive"
            onLabel={t('ΝΑΙ')}
            offLabel={t('ΟΧΙ')}
            onStyle={'success'}
            offStyle={'danger'}
          />
        </FormCol>

        <FormCol className="col-md">
          <FieldTextArea label={t('Σχόλια')} name="comments" disabled={!canEdit} />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol3 className="col-md">
          <FieldTextArea
            label={t('Σχόλια Οδηγού')}
            name="driverComments"
            disabled={!canEdit}
            rows={3}
          />
        </FormCol3>
      </FormRow>
    </div>
  );
};

export default QrCodeFormFields;
